import React from 'react';

const MembershipSubscriptionUserFormModal = React.lazy(() => import('../components/FormModal'));
const membershipSubscriptionUserModalRegistry = {
    core_membershipSubscriptionUserId: MembershipSubscriptionUserFormModal
};
export default membershipSubscriptionUserModalRegistry;
